import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useSoundEmission } from "../../hooks/useSoundEmission";

const SoundEmissionDropdown = ({ projectId, enabled }) => {
  const {
    isVisible,
    executions,
    dataStatus,
    selectedBatchId,
    selectExecution,
  } = useSoundEmission(projectId, enabled);

  if (!enabled || executions.length === 0) return null;

  return (
    <Dropdown item simple text="Sound Emission" className="drop-down">
      <Dropdown.Menu
        className="kkk"
        style={{ minWidth: "250px", transform: "translateY(-8px)" }}
      >
        {executions.map((execution) => {
          const batchId = execution.batch_id;
          const isSelected = isVisible && selectedBatchId === batchId;
          const isLoading =
            dataStatus === "loading" && selectedBatchId === batchId;

          return (
            <Dropdown.Item
              key={batchId}
              active={isSelected}
              disabled={isLoading}
              onClick={() => selectExecution(batchId)}
            >
              <div>
                <strong>{execution.name || `Execution ${batchId}`}</strong>
                <div style={{ fontSize: "0.85em", opacity: 0.75 }}>
                  Candidates: {execution.candidate_count ?? 0} · Receivers:{" "}
                  {execution.receiver_count ?? 0}
                  {isLoading ? " · Loading…" : ""}
                </div>
              </div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SoundEmissionDropdown;
